"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoWindowError = void 0;
var HttpStatusCodes_1 = require("./HttpStatusCodes");
var ValidationError_1 = require("./ValidationError");
var NoWindowError = /** @class */ (function (_super) {
    __extends(NoWindowError, _super);
    function NoWindowError(customMessage) {
        var _this = _super.call(this, customMessage) || this;
        _this.customMessage = customMessage;
        _this.errorCode = HttpStatusCodes_1.httpStatusCodes.NO_WINDOW.statusCode;
        _this.errorType = HttpStatusCodes_1.httpStatusCodes.NO_WINDOW.errorType;
        _this.message = 'It is not possible to get/set the visitorId in a server environment.';
        Object.setPrototypeOf(_this, NoWindowError.prototype);
        return _this;
    }
    NoWindowError.prototype.serializeErrors = function () {
        return [
            {
                message: this.message,
                customMessage: this.customMessage || '',
                errorCode: this.errorCode,
                errorType: this.errorType,
            },
        ];
    };
    return NoWindowError;
}(ValidationError_1.ValidationError));
exports.NoWindowError = NoWindowError;
